import { render, staticRenderFns } from "./AssignedProject.vue?vue&type=template&id=05b4c599"
import script from "./AssignedProject.vue?vue&type=script&lang=js"
export * from "./AssignedProject.vue?vue&type=script&lang=js"
import style0 from "./AssignedProject.vue?vue&type=style&index=0&id=05b4c599&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports